import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  
  to {
    opacity: 100;
  }
`;

export const shake = keyframes`
  0%, 90% {
    transform: translate3d(-2px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const slideDown = keyframes`
  from {
    transform: translateY(-10%);
  }

  to {
    transform: translateY(0);
  }
`;

export const zoom = keyframes`
  0%, 100%{
    width:60rem
  }

  35%{
    width: 50rem;
  }
`;

export const blink = keyframes`
  50%{
    opacity: 0.5;
  }
`;
